import type { NewsListItem } from 'types/capi/article';
import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';
import Tracked from '~/components/Tracked';
import useEnv from '~/hooks/useEnv';

const MODULE_TYPE = 'article-latest-news';

function toArticleCard(item: NewsListItem): ArticleCardType {
  return {
    author: { name: '', path: '' },
    id: item.id,
    images: [{ alt: item.image.alt, ratio: '16:9', url: item.image.url }],
    link: item.link,
    modified_at: item.modified_at,
    published_at: item.published_at ?? 0,
    section: item.category,
    title: item.link.text
  };
}

function ViewAllNewsButton() {
  const env = useEnv();

  return (
    <div className="w-36">
      <Tracked.ExternalLink
        variant="transparent-black-border"
        className="flex items-center justify-center"
        pagePosition="Homepage Latest News"
        name="VIEW_ALL"
        href={`${env.SITE_BASE_URL}/news/`}
      >
        View all news
      </Tracked.ExternalLink>
    </div>
  );
}

type CarouselProps = {
  items: NewsListItem[];
};

function Carousel({ items }: CarouselProps) {
  return (
    <div className="carousel-width no-scrollbar flex items-start gap-2 overflow-y-hidden md:gap-6">
      {items.map((i, index) => (
        <ArticleCard
          key={i.link.path}
          item={toArticleCard(i)}
          moduleType={MODULE_TYPE}
          name="LATEST_NEWS"
          pagePosition="Homepage Latest News"
          position={index + 1}
          variant="16/9-text-under"
        />
      ))}
    </div>
  );
}

type Props = { items: NewsListItem[]; title: string };

export default function ArticleCarousel({ items, title }: Props) {
  return (
    <div className="w-full bg-white">
      <div className="content-width flex flex-col items-center justify-center gap-6 py-10 md:py-20">
        <div className="flex flex-col justify-center gap-8 self-stretch">
          <h2 className="text-title-xl text-center">{title}</h2>
          <div className="flex flex-col items-center gap-6 md:gap-8">
            <Carousel items={items} />
            <ViewAllNewsButton />
          </div>
        </div>
      </div>
    </div>
  );
}
